import React from 'react';
import { useLocation } from 'react-router-dom';
import Api from '../../../api';

const CourseDetailsPage: React.FC = () => {
  const location = useLocation<{ lmsCourseId: number; launchUrl?: string }>();
  const courseId = location.state?.lmsCourseId;
  const [launchUrl, setLaunchUrl] = React.useState<string | undefined>(location.state?.launchUrl);
  const [loading, setLoading] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);
  const iframeRef = React.useRef<HTMLIFrameElement | null>(null);

  React.useEffect(() => {
    if (!courseId) return;
    if (launchUrl) return;
    setLoading(true);
    Api.updateToken()
      .then(() => Api.getCourseLaunchUrl(courseId))
      .then(({ url }: { url: string }) => setLaunchUrl(url))
      .catch(() => setError('Failed to load launch URL'))
      .finally(() => setLoading(false));
  }, [courseId, launchUrl]);

  const refreshProgress = async () => {
    if (!courseId) return;
    try {
      await Api.updateToken();
      await Api.getCourseProgress(courseId);
    } catch (e) {
      // ignore
    }
  };

  if (!courseId) return <div className="background">Missing course</div>;
  if (loading) return <div className="background">Loading...</div>;
  if (error) return <div className="background">{error}</div>;

  // If we have a launch URL, navigate the current tab to it. This avoids iframe third-party cookie issues.
  if (launchUrl) {
    window.location.href = launchUrl;
    return <div className="background">Redirecting to course…</div>;
  }

  return <div className="background" />;
};

export default CourseDetailsPage;


